export default function ForWho() {
  const profiles = [
    {
      icon: 'ri-movie-line',
      title: 'Atores, Músicos, Cantores, DJs',
      items: ['Interpretação cênica', 'Performance ao vivo', 'Presença de palco', 'Expressão artística']
    },
    {
      icon: 'ri-music-line',
      title: 'Dançarinos',
      items: ['Técnica corporal', 'Expressão através do movimento', 'Consciência espacial', 'Performance']
    },
    {
      icon: 'ri-boxing-line',
      title: 'Atletas e Lutadores',
      items: ['Alta performance', 'Foco mental', 'Controle emocional', 'Força interna']
    },
    {
      icon: 'ri-film-line',
      title: 'Diretores',
      items: ['Visão artística', 'Liderança criativa', 'Condução de equipes', 'Comunicação efetiva']
    },
    {
      icon: 'ri-presentation-line',
      title: 'Professores e Mestres',
      items: ['Autoridade pedagógica', 'Comunicação clara', 'Liderança educacional', 'Presença em sala']
    },
    {
      icon: 'ri-team-line',
      title: 'Treinadores',
      items: ['Condução de grupos', 'Motivação', 'Leitura comportamental', 'Desenvolvimento humano']
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Estudantes',
      items: ['7º ano ao ensino superior', 'Foco e disciplina', 'Organização interna', 'Direção de carreira']
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Militares & Forças de Segurança',
      items: [
        'Faixa preta de Jiu-Jitsu aplicado',
        'Defesa pessoal profissional',
        'Leitura de suspeitos e investigados',
        'Treinamentos em grupo ou personalizados',
        'Foco, disciplina e controle emocional',
        'Regeneração e recuperação de traumas',
        'Telepatia técnica e percepção ampliada',
        'Resistência mental em situações extremas'
      ]
    }
  ];

  return (
    <section id="para-quem" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-start">
          {/* Left Column */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-3xl p-10 shadow-sm sticky top-24">
              <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-6">
                Para Quem É
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                A AAPEQ é exclusiva para profissionais e estudantes que já estão em movimento. Não aceitamos iniciantes.
              </p>
              <div className="flex items-start gap-3 text-sm text-gray-600 italic">
                <i className="ri-checkbox-circle-fill text-[#F05954] text-xl flex-shrink-0 mt-0.5"></i>
                <p>Obrigatório comprovar atuação real ou estudo ativo</p>
              </div>
            </div>
          </div>

          {/* Right Column - Cards Grid */}
          <div className="lg:col-span-3">
            <div className="grid sm:grid-cols-2 gap-6">
              {profiles.map((profile, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#262364] to-[#F05954] flex items-center justify-center mb-5">
                    <i className={`${profile.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#262364] mb-4">{profile.title}</h3>
                  <ul className="space-y-2">
                    {profile.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-600">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#F05954] flex-shrink-0 mt-2"></span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
